// Always-visible red Stop control (Section 10). Every session screen shows
// exactly one of these, wired to a confirmation modal before abandoning.

export default function StopButton({ onClick, label = 'Stop' }) {
  return (
    <button type="button" onClick={onClick} className="btn-stop mt-3">
      {label}
    </button>
  );
}
